import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronDown, Menu, X, Rocket, Briefcase, Info, Mail } from 'lucide-react';

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <header className="page-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-20 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2">
          <img src="/assets/images/finovalogoor.png" alt="Finova" className="h-10 w-auto object-contain" />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-10">
          <Link to="/" className={`nav-link ${isActive('/') ? 'active' : ''}`}>Home</Link>
          
          {/* Services Dropdown */}
          <div className="dropdown-container group">
            <button className={`nav-link flex items-center gap-1 ${isActive('/services') ? 'active' : ''}`}>
              Services <ChevronDown size={14} className="group-hover:rotate-180 transition-transform" />
            </button>
            <div className="dropdown-menu">
              <Link to="/services" className="dropdown-item flex items-center gap-3">
                <Rocket size={16} className="text-primary-500" />
                <div>
                  <div className="font-bold">Quick Loan</div>
                  <div className="text-[10px] text-stripe-slate">Instant disbursement</div>
                </div>
              </Link>
              <Link to="/services" className="dropdown-item flex items-center gap-3">
                <Briefcase size={16} className="text-primary-500" />
                <div>
                  <div className="font-bold">Business Loans</div>
                  <div className="text-[10px] text-stripe-slate">Fuel your growth</div>
                </div>
              </Link>
            </div>
          </div>

          <Link to="/about" className={`nav-link ${isActive('/about') ? 'active' : ''}`}>About Us</Link>
          <Link to="/contact" className={`nav-link ${isActive('/contact') ? 'active' : ''}`}>Contact Us</Link>
        </nav>

        {/* Desktop Auth */}
        <div className="hidden lg:flex items-center gap-4">
          <Link to="/pay-online" className={`nav-link !scale-100 mr-2 ${isActive('/pay-online') ? 'active' : ''}`}>Pay Online</Link>
          <Link to="/login" className="btn-ghost px-6">Login</Link>
          <Link to="/register" className="btn-primary px-6 rounded-full">Get Started</Link>
        </div>

        {/* Mobile Menu Toggle */}
        <button 
          className="lg:hidden p-2 text-stripe-slate hover:bg-stripe-bg rounded-lg"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Nav */}
      {isOpen && (
        <div className="lg:hidden absolute top-full left-0 right-0 bg-white border-b border-stripe-border shadow-2xl animate-in slide-in-from-top duration-300">
          <div className="p-6 space-y-4">
            <Link to="/" onClick={() => setIsOpen(false)} className="block py-2 font-bold text-lg text-stripe-dark">Home</Link>
            <div className="py-2">
              <p className="text-xs font-bold text-stripe-light uppercase tracking-widest mb-4">Services</p>
              <div className="grid grid-cols-1 gap-4 pl-4 border-l-2 border-stripe-border">
                <Link to="/services" onClick={() => setIsOpen(false)} className="flex items-center gap-3">
                   <Rocket size={18} className="text-primary-500" />
                   <span className="font-bold text-stripe-dark text-sm">Quick Loan</span>
                </Link>
                <Link to="/services" onClick={() => setIsOpen(false)} className="flex items-center gap-3">
                   <Briefcase size={18} className="text-primary-500" />
                   <span className="font-bold text-stripe-dark text-sm">Business Loans</span>
                </Link>
              </div>
            </div>
            <Link to="/about" onClick={() => setIsOpen(false)} className="block py-2 font-bold text-lg text-stripe-dark">About Us</Link>
            <Link to="/contact" onClick={() => setIsOpen(false)} className="block py-2 font-bold text-lg text-stripe-dark">Contact Us</Link>
            <Link to="/pay-online" onClick={() => setIsOpen(false)} className="block py-2 font-bold text-lg text-primary-500">Pay Online</Link>
             
            <div className="pt-6 grid grid-cols-2 gap-4">
              <Link to="/login" onClick={() => setIsOpen(false)} className="btn-secondary w-full">Login</Link>
              <Link to="/register" onClick={() => setIsOpen(false)} className="btn-primary w-full">Register</Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
